module.exports = "/desktop-app/assets/img/time.png?54fe12aff0ca3cac8d12230be547c28e";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/time.png
// module id = 5f9d
// module chunks = 1